





























import {Component, Prop, Vue} from 'vue-property-decorator';
import theme from '../styles/theme.styl';
import {parseHourPreset} from '@/data/train-store';

@Component
export default class HourSelector extends Vue {
  @Prop() public hour!: string;
  @Prop() public presets!: Array<{ label: string, value: string }>;
  private classes = theme;
  private showPicker = false;

  private get timeValue() {
    return this.hourValue;
  }

  private set timeValue(hour) {
    this.onHourChange(hour);
  }

  private get presetsList() {
    return this.presets.map((x) => {
      return {
        label: x.label,
        selected: x.value === this.hour,
        value: x.value
      };
    });
  }

  private get hourValue() {
    return parseHourPreset(this.hour).hourStr;
  }

  private onHourChange(hour: string) {
    this.$emit('change', hour);
  }
}
